// src/hooks/useDesignerDetails.js
import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { setDesignerDetails, setError, clearDesignerDetails } from '../features/designerDetailsSlice';

const API_URL = 'https://api-4h4srbodqa-uc.a.run.app/api';
// const API_URL = 'http://localhost:4000';

export const useDesignerDetails = (userUId, userRole) => {
  const dispatch = useDispatch();

  return useQuery({
    queryKey: ['designerDetails', userUId, userRole],
    queryFn: async () => {
      const { data } = await axios.get(`${API_URL}/designers/`);
      console.log('Raw API response:', data); // Log the raw API response
      return data;
    },
    onSuccess: (data) => {
      console.log('Setting Designer Details in Redux:', data);
      dispatch(setDesignerDetails(data));
    },
    onError: (error) => {
      console.error('Fetch error:', error);
      dispatch(setError(error.message));
    },
    refetchInterval: 5000,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });
};